module.exports = __webpack_public_path__ + "static/media/IMG_0109.c6315e03.jpg";